export const INITIATE_CUSTOMER_SEARCH = 'INITIATE_CUSTOMER_SEARCH';
export const CUSTOMER_SEARCH_SUCCESS = 'CUSTOMER_SEARCH_SUCCESS';
export const CUSTOMER_SEARCH_CLEAR_RESULTS = 'CUSTOMER_SEARCH_CLEAR_RESULTS';

export const onCustomerSearchChange = (searchTerm) => ({
  type: INITIATE_CUSTOMER_SEARCH,
  searchTerm,
});

export const customerSearchSuccess = (searchResults) => ({
  type: CUSTOMER_SEARCH_SUCCESS,
  searchResults,
});

export const clearCustomerSearch = () => ({
  type: CUSTOMER_SEARCH_CLEAR_RESULTS,
});
